import * as Sentry from "@sentry/react";
import { SonnerToaster, ThemeProvider } from "@simplicity/ui";
import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { ErrorFallback } from "./components/ErrorFallback.tsx";
import "./index.css";
import { initSentry } from "./sentry.ts";

initSentry();

// In dev mode, run axe-core on every render and log a11y violations to the console.
// Tree-shaken out of production builds.
if (import.meta.env.DEV) {
  void import("@axe-core/react").then((axe) => axe.default(React, ReactDOM, 1000));
}

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");
ReactDOM.createRoot(rootElement).render(
  <StrictMode>
    <ThemeProvider attribute="class" defaultTheme="dark">
      <Sentry.ErrorBoundary fallback={ErrorFallback} showDialog={false}>
        <App />
      </Sentry.ErrorBoundary>
      <SonnerToaster position="top-right" theme="dark" />
    </ThemeProvider>
  </StrictMode>,
);
